export default __webpack_public_path__ + "static/media/GajendraJingar.fdd3b382.jpeg";